import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link, useParams } from 'react-router-dom';
import { CandidatoService, ReadCandidatoDto } from './candidato.service';
import { ProcessoSeletivoService } from '../processo-seletivo/processo-seletivo.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useEffect, useState } from 'react';

const candidatoService = new CandidatoService();
const processoSeletivoService = new ProcessoSeletivoService();

export default function CandidatoIndexPage() {
  const params = useParams();
  const processoSeletivoId = params.id ? Number(params.id) : undefined;
  
  const [registros, setRegistros] = useState<[ReadCandidatoDto[], number]>();
  const [processoSeletivo, setProcessoSeletivo] = useState<{ nome: string } | null>(null);
  const tableState = useDataTableState('dataInscricao');

  useEffect(() => {
    if (processoSeletivoId) {
      // Carregar informações do processo seletivo
      processoSeletivoService.findOne(processoSeletivoId)
        .then((result) => {
          setProcessoSeletivo({ nome: result.nome });
        })
        .catch((error) => {
          console.error('Falha ao carregar processo seletivo:', error);
        });
    }
  }, [processoSeletivoId]);

  const handleBuscar = () => {
    candidatoService.findAll({
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
    }, processoSeletivoId).then((result) => {
      setRegistros(result);
    }).catch((res) => {
      toast.error(String(res) || '');
    });
  };

  useEffect(() => {
    if (processoSeletivoId) {
      handleBuscar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processoSeletivoId]);

  const formatarData = (data: Date) => {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const formatarSituacao = (situacao: string) => {
    const situacaoMap: Record<string, string> = {
      'inscricao_realizada': 'Inscrição Realizada',
      'inscricao_validada': 'Inscrição Validada',
      'indeferida': 'Indeferida',
      'classificada': 'Classificada',
      'convocada': 'Convocada',
    };
    return situacaoMap[situacao] || situacao;
  };

  const handleExcluir = async (id: number, nome: string) => {
    if (!window.confirm(`Tem certeza que deseja excluir o candidato "${nome}"?\n\nEsta ação não pode ser desfeita.`)) {
      return;
    }

    try {
      await candidatoService.delete(id);
      toast.success('Candidato excluído com sucesso!');
      handleBuscar();
    } catch (error: any) {
      toast.error(error?.message || 'Erro ao excluir candidato.');
    }
  };

  let colunas: Column<ReadCandidatoDto>[] = [
    {
      key: "pessoaNome",
      header: "Nome",
      render: (row) => row.pessoaNome || '-',
    },
    {
      key: "pessoaCpf",
      header: "CPF",
      render: (row) => row.pessoaCpf || '-',
    },
    {
      key: "pessoaEmail",
      header: "E-mail",
      render: (row) => row.pessoaEmail || '-',
    },
    {
      key: "pessoaTelefone",
      header: "Telefone",
      render: (row) => row.pessoaTelefone || '-',
    },
    {
      key: "comarcaPretendidaNome",
      header: "Comarca",
      render: (row) => row.comarcaPretendidaNome || '-',
    },
    {
      key: "distritoPretendidoNome",
      header: "Distrito",
      render: (row) => row.distritoPretendidoNome || '-',
    },
    {
      key: "cursoPretendidoNome",
      header: "Curso",
      render: (row) => row.cursoPretendidoNome || '-',
    },
    {
      key: "dataInscricao",
      header: "Data de Inscrição",
      render: (row) => formatarData(row.dataInscricao),
    },
    {
      key: "situacao",
      header: "Situação",
      render: (row) => formatarSituacao(row.situacao),
    },
    {
      key: "acoes",
      header: "Ações",
      render: (row) => (
        <div className="d-flex gap-2">
          <Link className="link-secondary" to={`/candidato/${row.id}`}>
            Ver Detalhes
          </Link>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleExcluir(row.id, row.pessoaNome || 'Candidato')}
            title="Excluir candidato"
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-8">
        <h3 className="pt-4">
          Candidatos
          {processoSeletivo && ` - ${processoSeletivo.nome}`}
        </h3>
        <span className="blockquote-footer pb-4 text-end">
          Listagem de candidatos inscritos no processo seletivo.
        </span>
      </div>
      <div className="col-md-4">
        <br />
        <Link
          type="button"
          className="btn btn-secondary float-end"
          to={Links.ProcessoSeletivo_Index}
        >
          Voltar
        </Link>
      </div>
      <hr className="pb-4" />

      {registros &&
        <DataTable
          columns={colunas}
          data={registros[0]}
          initialSortKey="dataInscricao"
          onChange={handleBuscar}
          serverSide={true}
          states={tableState}
          totalRecords={registros[1]}
        />
      }
    </div>
  );
}

